import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const DelayIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Delay",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M25.69 10.61V5.23h.53c.89 0 1.62-.72 1.62-1.62s-.72-1.62-1.62-1.62H5.77c-.89 0-1.62.72-1.62 1.62s.72 1.62 1.62 1.62h.53v5.38c0 .56.29 1.05.72 1.34S13.08 16 13.08 16l-6.06 4.04c-.44.29-.72.79-.72 1.34v5.39h-.53c-.89 0-1.62.72-1.62 1.62s.72 1.62 1.62 1.62h20.46c.89 0 1.62-.72 1.62-1.62s-.72-1.62-1.62-1.62h-.53v-5.39c0-.56-.29-1.05-.72-1.34s-6.06-4.05-6.06-4.05l6.06-4.04c.43-.3.71-.79.71-1.34m-3.22 11.64v4.52h-2.15v-1.92c0-.75-.39-1.41-.97-1.8s-2.22-1.35-2.22-1.35c-.32-.21-.72-.33-1.14-.33s-.82.12-1.15.33-2.15 1.34-2.15 1.34a2.16 2.16 0 0 0-1.01 1.82v1.89H9.56v-4.51l6.46-4.31 6.46 4.31Zm0-12.5-6.46 4.3-6.46-4.3V5.23h12.93v4.52Z"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M16 30C9.38 30 4 24.62 4 18S9.38 6 16 6s12 5.38 12 12-5.38 12-12 12m0-22C10.49 8 6 12.49 6 18s4.49 10 10 10 10-4.49 10-10S21.51 8 16 8"
      }), /*#__PURE__*/_jsx("path", {
        d: "M20.24 23.24c-.26 0-.51-.1-.71-.29l-4.24-4.24a.996.996 0 1 1 1.41-1.41l4.24 4.24a.996.996 0 0 1-.71 1.7ZM19 4h-6c-.55 0-1-.45-1-1s.45-1 1-1h6c.55 0 1 .45 1 1s-.45 1-1 1"
      }), /*#__PURE__*/_jsx("path", {
        d: "M16 8c-.55 0-1-.45-1-1V3c0-.55.45-1 1-1s1 .45 1 1v4c0 .55-.45 1-1 1M21.5 9.47c-.17 0-.34-.04-.5-.13a1.01 1.01 0 0 1-.37-1.37l1.5-2.6c.28-.48.89-.64 1.37-.37.48.28.64.89.37 1.37l-1.5 2.6c-.19.32-.52.5-.87.5"
      })]
    })
  }));
};